import newsContents from "@/api/newsContents";
const navData = [{
  path: "/main",
  name: "main",
  pageName: "首页"
},
{
  path: "/product",
  name: "product",
  pageName: "产品中心",
},
{
  path: "/news",
  name: "news",
  pageName: "新闻资讯",
}];

const navSubData = [{
  path: "/product/techmanage",
  name: "techmanage",
  pageName: "工艺报警管理系统"
},
{
  path: "/product/harmfulalarm",
  name: "harmfulalarm",
  pageName: "有毒有害风险监控预警系统",
},
{
  path: "/product/systemdb",
  name: "systemdb",
  pageName: "实时数据库系统",
},
{
  path: "/product/productwatch",
  name: "productwatch",
  pageName: "生产监控系统",
}
];

const systemTechData = [
  {
    title: "产品背景",
    content: [
      {
        subTitle: "",
        contentText: `
<p>&ensp;&ensp;&ensp;&ensp;分布式控制系统（DCS）现已广泛应用于石油化工领域。DCS报警系统已从早期的模拟式、单点式发展为现在的报警列表式，并具有完备的报警处理功能。随着生产过程和设备变得越来越复杂、要求越来越严格，报警点也相应地不断增加，与此同时报警处理课题成为近年关注的焦点，因此报警汇总和处理在工厂管理中越来越受到重视。</p>
            <p>&ensp;&ensp;&ensp;&ensp;国外大多数DCS系统都具有报警处理过程，支持报警判断、报警储存、报警查询和报警确认等功能，通过报警判断功能减少装置不必要的报警发生，同时报警存储将报警信息写入报警表进行有效管理，以方便故障分析。运用报警查询功能，操作人员可按照报警条件进行查看，快速识别最危险信息。实现了报警管理的科学化与信息化。</p>
            <p>&ensp;&ensp;&ensp;&ensp;洞见信息科技基于EEMUA191 Alarm Systems AGuide to Design, Management and Procurement，ISA-18.2 Managementof Alarm Systems for the Process Industries等国际标准，以及GB 41261-2022《过程工业报警系统管理》、T/CCSAS012-2022《化工企业工艺报警管理实施指南》中的技术标准和管理要求，和企业工艺安全的管理经验，自主研发了工艺报警管理系统，系统通过对报警相关数据评估企业报警管理现状，支持报警原因分析，充分发挥报警管理系统的能力，扩大报警管理系统实施效果，提升生产装置的报警系统性能，从而提高装置运行稳定性，减少装置工艺波动，确保各装置可以长期有效地使用报警管理。</p>
`,
      }
    ]
  },
  {
    title: "产品功能",
    content: [
      {
        subTitle: "仪表点位数据的采集和储存",
        contentText: `
          <p>&ensp;&ensp;&ensp;&ensp;系统是一个具有开放体系结构的系统，它同时具备完整的实时数据库系统与时序数据库系统功能，既满足了高并发的实时“窄”数据的处理，也满足了大数据分析需求的宽数据压缩存储，无缝集成关系数据库系统(RDBMS)，以应用程序接口（API）和关系数据库接口等多种方式为第三方应用软件系统提供集成能力。<p/>
          <p>&ensp;&ensp;&ensp;&ensp;将分散在各个系统中的仪表数据集成起来，并将原始信息进行重新定义及标准化处理之后存储到数据库中，实现分布式过程数据的实时采集、实时规则推理、海量历史数据管理等。<p/>`
      },
      {
        subTitle: "报警数据统计和展示",
        contentText: `
          <p>&ensp;&ensp;&ensp;&ensp;系统根据数据测量值与报警规则库中的设定值进行比较输出报警事件。系统支持对报警次数、报警持续时间，结合报警所属的行政单位、管理分类、报警等级、响应优先级进行多维度统计，在系统首页、报表中心中展示，便于相关人员查阅。<p/>`,
        imgSrc: "product_module2.png"
      }, {
        subTitle: "报警电子台账和维护",
        contentText: `<p>&ensp;&ensp;&ensp;&ensp;电子化台账支持线上维护，并提供报警高级属性的设置，如报警分类、分级、响应优先级、死区值、延时值等内容设定，系统支持设置报警原因和处置方法，并可以在报警处置记录模块中形成知识库。支持在系统中编辑、维护报警设置信息，并自动对变更内容进行记录。<p/>`,
        imgSrc: "product_module3.png"
      },
      {
        subTitle: "报警分析",
        contentText: `<p>&ensp;&ensp;&ensp;&ensp;系统支持对频繁发生的报警、关键报警、陈旧报警进行统计、排序，支持对一年的数据进行自动分析，根据算法规则自动判定出干扰报警（振颤报警、瞬闪报警），支持模拟值设定，预测报警属性修改后的效果，并自带报警原因分析的知识库内容。<p/>`,
        imgSrc: "product_module2.png"
      },
      {
        subTitle: "异常事件分析",
        contentText: `<p>&ensp;&ensp;&ensp;&ensp;系统可自动或手动判定工厂的异常情况，对异常情况发生前的报警情况进行汇集、分析，判定报警未能起到作用的原因，用以改进报警的可靠性。<p/>`,
        imgSrc: "product_module5.png"
      },
      {
        subTitle: "报警处置记录",
        contentText: `<p>&ensp;&ensp;&ensp;&ensp;系统支持汇集各个班组的报警发生情况，并进行聚合记录和详细内容展示，支持知识库快捷录入原因分析和处置方法，支持记录人通过手写板签字确认和PIN码方式确认。<p/>`,
        imgSrc: "product_module6.png"
      }
    ]
  }
];

const mainProductInfos = [
  {
    bgImg: "main-product-bg0.png",
    itemName: "工艺报警管理系统",
    itemDesc: "通过警报管理分析过去转变为预测即将发⽣的情况， 并为运营团队提供时间来避免警报、 设备问题并保护产品质量。 使⽤智能分析和警报减少技术减少操作员的警报负载 对异常情况进行分析， 为下一次异常情况的未来发⽣和解决向操作员提供预测、 洞察和建议。",
    path: navSubData[0].path,
  },
  {
    bgImg: "main-product-bg1.png",
    itemName: "有毒有害风险监控预警系统",
    itemDesc: "气体泄漏会对工业工厂、其员工以及附近居住人员造成持续的威胁。涉及窒息或爆炸的全球性事件不断提醒着这个问题。当快速而明智的决定生死攸关时，您需要完全掌控您的气体探测系统。确保安全和合规比以往更容易，同时还可以减少设置和操作时间，并最大程度减少培训需求。",
    path: navSubData[1].path,
  },
  {
    bgImg: "main-product-bg3.png",
    itemName: "实时数据库系统",
    itemDesc: "基于数字孪生技术打造智慧工厂，实现工厂的全要素数字化和虚拟化,生产管理实时化和可视化；基于机器学习实现设备运维协同化和智能化，助力工业企业实现数字化运营。",
    path: navSubData[2].path,
  },
  {
    bgImg: "main-product-bg2.png",
    itemName: "生产实时监控系统",
    itemDesc: "基于数字孪生技术构建的智慧工厂，能够直观地将厂区建筑及各领域管理要素得到精准复现，并基于全域数据信息，建立一系列业务决策模型，能够实现对当前状态的评估、对过去发生问题的诊断，以及对未来趋势的预测，为业务决策提供科学依据。",
    path: navSubData[3].path,
  },

];

const mainSolutionInfos = [
  {
    imgSrc: "solution-item-pic2.png",
    title: "大数据平台",
    desc: "为海量多源异构数据的提供高频采集、机理建模、工艺报警分析、工艺流程优化、设备端安全防护、基于实时数据库的产品全生命周期建模和面向生产过程优化分析能力。",
  },
  {
    imgSrc: "solution-item-pic3.png",
    title: "中小企业上云",
    desc: "为客户提供轻量化套餐和个性化定制服务， 实现中小企业上云。",
  },
  {
    imgSrc: "solution-item-pic4.png",
    title: "重点设备上云",
    desc: "为传统工业设备增加信息采集功能，完成智能化改造，提供远程运维服务。",
  },
  {
    imgSrc: "solution-item-pic5.png",
    title: "智能工厂改造",
    desc: "为传统工厂定制打造基于工业大数据驱动的智能化工厂，助力企业数字化转型。",
  },
  {
    imgSrc: "solution-item-pic6.png",
    title: "标识解析",
    desc: "在石化行业对每台设备赋予一个唯一的身份标识，提供对高价值设备的运维和诊断能力。",
  },
];

const systemHarmfulAlarmData = [
  {
    title: "产品简介",
    content: [
      {
        subTitle: "",
        contentText: `<p>&ensp;&ensp;&ensp;&ensp;环境风险预警体系建设，就是本着“常态与非常态相结合，预防与处置并重”的原则，使本质安全与环境安全有机融合，将环境风险和安全隐患的管控“关口前移”，集“源头管控、快速联动、平战结合、统筹兼顾”于一体，由“事后疲于应付”转变为“事前科学预防”，真正做到“防患于未然，治患于萌芽”。 通过管理系统的建设，实现强化化工园区和企业环境风险防控、保障生产安全，提升化工园区精细化管理水平，有效监测有毒有害气体排放，促进我省大气环境质量改善和化工园区高质量发展的目的。进而落实习总书记从源头防范化解重大风险的现代化的治理体系、提升治理能力。报警管理系统，系统通过对报警相关数据评估企业报警管理现状，支持报警原因分析，充分发挥报警管理系统的能力，扩大报警管理系统实施效果，提升生产装置的报警系统性能，从而提高装置运行稳定性，减少装置工艺波动，确保各装置可以长期有效地使用报警管理。</p>`
      }
    ]
  },
  {
    title: "产品背景",
    content: [
      {
        subTitle: "",
        contentText: `<p>&ensp;&ensp;&ensp;&ensp;随着化工企业“退城入园”政策的推进，化工园区日益成为危险化学品、有毒有害物质主要的聚集地。尤其部分化工园区在发展中还存在着规模体量小、园区功能定位不明确、主导产业不突出甚至还存在低水平重复建设、同质化现象明显、管理水平参差不齐、有毒有害气体监测装置利用率低、监测装置损坏、报警装置无输出等问题，安全生产与环境风险隐患较为突出，一旦发生泄漏、火灾、爆炸等安全生产事故，极易产生“多米诺骨牌”效应，不仅造成生态环境破坏，而且给企业、园区及周边敏感目标造成重大伤亡和巨大财产损失。 为深入贯彻习近平生态文明思想，认真落实省委省政府《山东省贯彻落实〈关于构建现代环境治理体系的指导意见〉的若干措施》、山东省生态环境厅、工信厅《关于印发全省化工园区有毒有害气体环境风险预警体系建设工作方案的通知》、生态环境厅全省化工园区环境风险预警体系建设工作推进视频会的工作部署，我公司结合自身特点打造了有毒有害气体环境风险监控预警管理系统。</p>`
      }
    ]
  },
  {
    title: "产品功能",
    content: [
      {
        subTitle: "",
        contentText: `<p>&ensp;&ensp;&ensp;&ensp;管理系统主要包括大数据中心、能力支撑平台、数据库子系统、预警子系统、应急响应子系统、数据分析子系统、信息公开子系统等模块。通过建立园区三维GIS平台，整合化工园区和企业危险单元、风险源、监测站点/装置、应急资源与设施以及周边环境等的基本信息与分布位置，构建“点、线、面”自动监测网络，依靠监测网络数据的实时回传，将整个园区的日常监测、监控预警、应急联动等集成到统一的平台上进行综合管控，实时监测园区污染物的迁徙路径，明晰园区各企业特征污染物排放及扩散规律，实现“实时监控、风险预警、数据处理、应急响应、信息发布”等功能。</p>`,
        imgSrc: "harmful_function.png"
      }
    ]
  }
];

const systemDbData = [
  {
    title: "实时数据库系统简介",
    contentText: [
      "<p>&ensp;&ensp;&ensp;&ensp;实现从数据到信息，从信息到生产力的转换可靠、准确、实时的信息，意味着可做出更好的业务决策。对企业或管理机构而言，洞见信息自主研发的实时数据库系统的应用，意味着企业或管理机构中每位成员都可根据工作需求实时获得关键的数据。利用实时数据库系统，将数据转化为对业务有用的信息，该信息将辅助管理者和运行人员做出适当的决策，使企业不断的向前发展并获得增长性的赢利能力。实时数据库系统为管理层打开一扇虚拟的窗口，帮助其洞察生产过程或运行流程，使得在大量基于实际运行数据/信息基础上，实现对整个业务运作流程的控制与管理。</p>"
    ],
    imgSrcs: [
      "db_content0.png"
    ]
  },
  {
    title: "实时数据库系统核心功能",
    contentText: ["具有强大的实时数据采集功能，可实时地采集来自不同数据源的原始数据，并通过系统提供的用户可配置报表、分析工具和Web 软件工具等，在遍布企业或管理部门的台式计算机、便携式电脑或手机上，实时显示当前和历史的运行状况。对于运行管理有价值的数据信息，系统可为其提供在线存储达数十年，并随时随地（每周7 天、每天24 小时）连续不断地为运行单元级、成套设施级、整个企业或管理机构级，提供实时数据与信息支持。",
      "弥合了业务控制与业务管理间的信息缺口，使得该类企业在实时数据支持的管理过程中成功地获得了丰厚的投资回报，且避免了运营风险和决策失误。实时数据库系统已成为企业或管理机构的信息集成系统重要部分，直接应用于运行、维护和管理一体化。并为生产过程控制与业务运行和管理系统间的实时信息沟通架起了一道桥梁。实时数据库系统可直接采集，实时获取难度较高的各种运行过程中的实时数据（通常该类数据，封闭在各自成体系的自动化系统或人工数据源中），并将其转化为公共的、且对业务有效的信息。不论何种行业或管理部门，均可从这些关键的实时信息中获得收益，并能在动态业务领域中自由地驰骋，达到绩效目标。",
      "帮助企业将实时数据转化为运行管理决策的关键信息，使其成为业务系统中整合的重要信息。目前，众多管理机构、组织或企业，包括世界500 强到中型规模企业，将该实时信息管理模式应用到生产能力、产品质量和可靠性方面后，而取得了持续的巨大成功。"
    ],
    imgSrcs: ["db_content1.png"]
  }
];

const systemWatchData = [
  {
    title: "图形展示",
    contentText: [
      "实时展示企业现场工艺流程状态，涵盖流量、温度、压力、液位等重要参数信息； ",
      "实时跟踪罐区资源的动态，包括压力、液位、温度等，同时也展示储罐的静态数据，如罐高、安全罐容、设计罐容、设计制造时间等信息，通过罐区跟踪及时了解罐存情况 （MES系统）；",
      "实时监控当前全厂公用工程数据信息，数据主要包括：水、电、气、风等相关数据，通过这些数据实时在线分析生产能耗情况； ",
      "实时监控大型机组等关键设备运行状态；",
      "实时监控实验室采样分析点相关信息，包括采样点状态、分析项目数据、历史采样情况等； ",
      "第一时间掌握生产一线的实时数据，把控生产方向，指导生产过程, 满足用户对生产现场情况的监控需求； ",
      "支持HTML5技术，无需软件辅助。"
    ],
    imgSrcs: [
      "watch_graph_0.png",
      "watch_graph_1.png",
      "watch_graph_2.png",
    ]
  },
  {
    title: "历史曲线",
    contentText: [
      "方便的观察数据库中的历史点在任意一个时刻的状态，方便的查询某个位号的历史曲线，分析某一液位点、温度点、压力点、流量等的运行情况，并打印趋势。方便生产管理人员掌握过去生产的变化趋势； ",
      "实现了生产工艺指标多曲线对比功能； ",
      "提供了对位号历史的追溯，帮助工艺人员对具体参数的历史数据进行分析和总结。"
    ],
    imgSrcs: ["watch_history_0.png"]
  },
  {
    title: "工艺台账",
    contentText: [
      "查询各时间点工艺台帐记录，动态生成电子工艺台帐报表，替代传统的纸质台帐； ",
      "在线抄表模式：内操在生产流程图中对重要位号进行在线抄表，在兼顾监管作用的同时，替代外操户外抄表；",
      "是进行工艺技术改进和历史追溯的重要依据； ",
      "电子工艺台帐可随时导出至Excel文件或生成相应台帐报表。"
    ],
    imgSrcs: ["watch_craft_0.png"]
  },
  {
    title: "位号报警",
    contentText: [
      "系统提供报警数据点集中管理和展示功能，通过该功能用户可以方便快捷的查询浏览到生产运行过程中的报警状态，及时调整生产运行指令； ",
      "组态位号报警信息，对于位号不同的报警情况采用不同颜色来区别，报警类型包括位号超限报警、位号离散报警、位号直线报警、位号变化率报警、位号方差报警； ",
      "对重要参数的超限情况发出报警处理，与生产流程监控模块联动，通过图形颜色的变化提醒岗位操作人员； ",
      "报警信息可随时导出至Excel文件或者生产相关报警报表；",
      " 报警信息可根据权限设置，与短信平台进行集成，将报警信息发送至关键用户。"
    ],
    imgSrcs: ["watch_alarm_0.png"]
  },
  {
    title: "报警处置",
    contentText: [
      "报警处置自动生成报警的相关记录，并根据振幅、时长等信息进行了聚合，岗位人员能快速准确定位报警的为止；",
      "系统提供报警产生原因和相关处置的知识库，支持在报警台账进行维护，班组人员可以简单、快捷的对报警处置记录。"
    ],
    imgSrcs: ["watch_deal_0.png"]
  },
];

const newsItemData = [
  {
    id: 0,
    time: "2023-08-21",
    title: "关于印发工业互联网危化安全生产5项指南的通知",
    imgSrc: "news_img6.png",
    desc: "",
    content: newsContents.newsId6
  },
  {
    id: 1,
    time: "2023-07-10",
    title: "《化工企业工艺报警管理实施指南》（TCCSAS012—2022）",
    imgSrc: "news_img7.png",
    desc: "",
    content: newsContents.newsId7
  },
  {
    id: 2,
    time: "2022-11-15",
    title: "《工业大数据白皮书（2019版）》",
    imgSrc: "news_img0.png",
    desc: "",
    content: newsContents.newsId0
  },
  {
    id: 3,
    time: "2022-10-12",
    title: "工业和信息化部关于推动5G加快发展的通知",
    imgSrc: "news_img1.png",
    desc: "为贯彻落实《推进互联网协议第六版(IPv6)规模部署行动计划》（厅字〔2017〕47号）任务要求，加快提升IPv6端到端贯通能力，持续提升......",
    content: newsContents.newsId1,
  },
  {
    id: 6,
    time: "2022-06-22",
    title: "一图看懂关于推动工业互联网加快发展的通知",
    imgSrc: "news_img4.png",
    mainImgSrc: "news_main_content_0.png",
    desc: "为深入贯彻习近平总书记在统筹推进新冠肺炎疫情防控和经济社会发展工作部署会议上的重要讲话精神，落实中央关于推动工业互联网加快发展的决策部署，统筹发展与安全，推动工业互联网在更广范围、更深程度、更高水平上融合创新，培植壮大经济发展新动能，支撑实现高质量发展，工业和信息化部日前印发《关......",
    content: newsContents.newsId4,
  },
  {
    id: 4,
    time: "2022-09-30",
    title: "工业和信息化部办公厅关于推动工业互联网加快发展的通知",
    imgSrc: "news_img2.png",
    desc: "各省、自治区、直辖市及计划单列市、新疆生产建设兵团工业和信息化主管部门，各省、自治区、直辖市通信管理局，中国电信集团有限......",
    content: newsContents.newsId2,
  },
  {
    id: 5,
    time: "2022-08-11",
    title: "《工业和信息化部办公厅关于推动工业互联网 加快发展的通知》政策解读",
    imgSrc: "news_img3.png",
    desc: "党中央、国务院高度重视工业互联网发展。习近平总书记连续四年对推动工业互联网发展做出重要指示。今年2月21日，中央政治局会议再......",
    content: newsContents.newsId3,
  },
  {
    id: 7,
    time: "2022-05-11",
    title: "《工业互联网创新发展行动计划（2021-2023 年）》解读",
    imgSrc: "news_img5.png",
    desc: "近日，工业互联网专项工作组印发《工业互联网创新发展行动计划（2021-2023年）》（工信部信管〔2020〕197号，以下简称《三年行动计划》）。现就《三年行动计划》有关内容解读如下：",
    content: newsContents.newsId5,
  },
]

export default {
  navData, navSubData, systemTechData, mainProductInfos, mainSolutionInfos, systemHarmfulAlarmData, systemDbData,
  systemWatchData, newsItemData,

};
